import { TenantEntity } from '../TenantEntity'

export class WareHouseRegion extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get wareHouseUuid() {
    return this._data.wareHouseUuid
  }
  set wareHouseUuid(wareHouseUuid) {
    this._data.wareHouseUuid = wareHouseUuid || null
  }
  get regionUuid() {
    return this._data.regionUuid
  }
  set regionUuid(regionUuid) {
    this._data.regionUuid = regionUuid || null
  }
  get regionName() {
    return this._data.regionName
  }
  set regionName(regionName) {
    this._data.regionName = regionName
  }
  get regionEnglishName() {
    return this._data.regionEnglishName
  }
  set regionEnglishName(regionEnglishName) {
    this._data.regionEnglishName = regionEnglishName
  }
}
